import { createSlice } from "@reduxjs/toolkit";
import { subDays } from "date-fns";

export const initialState = {
  loading: false,
  error: { error: false },
  eventTable: {
    loading: false,
    error: { error: false },
    columns: [],
    units: "imperial",
    selectedCameras: {},
    selectedDateRange: [
      subDays(new Date(), 30).toISOString(),
      new Date().toISOString()
    ],
    filters: {
      source: null,
      humanActivity: null
    },
    sortSetting: {
      columnToSort: "start",
      sortDirection: "desc"
    }
  }
};

const slice = createSlice({
  name: "Event",
  initialState,
  reducers: {
    setTableColums: (state, action) => {
      state.eventTable.columns = action.payload;
    },
    setSelectedCameras: (state, action) => {
      state.eventTable.selectedCameras = {
        ...state.eventTable.selectedCameras,
        ...action.payload
      };
    },
    setSelectedDateRange: (state, action) => {
      state.eventTable.selectedDateRange = action.payload.map(date =>
        date instanceof Date ? date.toISOString() : date
      );
    },
    resetFilters: state => {
      state.eventTable.selectedCameras = {};
      state.eventTable.selectedDateRange =
        initialState.eventTable.selectedDateRange;
      state.eventTable.filters = initialState.eventTable.filters;
    },
    setFilters: (state, action) => {
      state.eventTable.filters = {
        ...state.eventTable.filters,
        ...action.payload
      };
    },
    setSortSetting: (state, action) => {
      state.eventTable.sortSetting = action.payload;
    }
  }
});

export const EventsPageActions = {
  ...slice.actions
};

export const EventsPageReducer = slice.reducer;
